import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class SignOutCommand {
  constructor(private httpClient: HttpClient) {}

  call(): Observable<any> {
    const url = `${environment.api.app}/sessions/revoke`

    const params = {}

    return this.httpClient.post(url, params).pipe(
      map(() => {
        return null
      })
    )
  }
}
